import {
  getSubscriptionsPending,
  getSubscriptionsSuccess,
  getSubscriptionsError,
  checkoutSubscriptionPending,
  checkoutSubscriptionsSuccess,
  checkoutSubscriptionsError,
} from "../actions/subscription";

import { SubscriptionService } from "../../lib/qc-api-client";

export function getSubscriptions() {
  return (dispatch) => {
    dispatch(getSubscriptionsPending());
    SubscriptionService.getSubscriptions()
      .then((response) => {
        dispatch(
          getSubscriptionsSuccess({
            subscriptions: response.data.subscriptions,
            userSubscription: response.data.user_subscription,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(getSubscriptionsError(error));
      });
  };
}

export function checkoutSubscriptions(data) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionPending());
    SubscriptionService.checkoutSubscriptions(data)
      .then((response) => {
        dispatch(
          checkoutSubscriptionsSuccess({
            subscriptions: response.data,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(checkoutSubscriptionsError(error));
      });
  };
}

export function reattemptPayment(data) {
  return (dispatch) => {
    dispatch(checkoutSubscriptionPending());
    SubscriptionService.reattemptPayment(data)(data)
      .then((response) => {
        dispatch(
          checkoutSubscriptionsSuccess({
            subscriptions: response.data,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(checkoutSubscriptionsError(error));
      });
  };
}
